const DEFAULT_DISPLAY_SETTINGS_BLOCK = {
    container_style: {
        border_color: "#8614dd",
        border_radius: 8,
        border_width: 1,
        background_color: "#ffffff"
    },
    text_display: {
        header_title: "Free Gift",
        remain_title: "Buy {{remain}} more to get free the below(s):",
        achieve_title: "Congratulation you get a free gift!",
        claim_button: "Claim",
        claimed_button: "Claimed",
        gift_icon_text: "Have one gift to claim",
        gift_icon_text_claimed: "You've earned the gift!",
        optional_message: "Choose {{gift_number}} from list below:",
        optional_message_auto_add: "You will earn {{gift_number}} gifts",
        choose_gift_message: "You can choose {{gift_remain}} gifts more.",
        choose_enough_gift_message: "You've chosen enough gifts.",
        upsell_message_qty: "Buy {{product}}(x{{remain}}) to get a free gift.",
        upsell_message_amount: "Subtotal of {{product}} need reach to {{remain}} to get a free gift",
        free_text_content: "Free",
        error_message: "Some errors happen. Can not claim now, please try again later.",
        claim_all_gift_message: "You claimed all of gifts.",
        warning_message: "You must choose enough gift."
    },
    header_style: {
        color: "#ffffff",
        background_color: "#000000",
        padding: 10,
        block_color: "#000000"
    },
    block_btn_style: {
        color: "#ffffff",
        padding: 0,
        background_color: "#8614dd",
        font_size: 14,
        font_weight: 700
    },
    gift_item_style: {
        free_label_and_checkbox_color: "#8614dd",
        color: "#000000",
        helptext_color: "#bdbdbd"
    },
    gift_icon_style: {
        is_icon_displayed: true,
        color: "#000000",
        icon_color: "#8614dd",
        background_color: "#ffffff",
        border_color: "#ffffff",
        border_width: 0,
        border_radius: 35,
        free_gift_image: null
    },
    cart_btn_selector: ""
}

class tlFreeGiftBlock {
    APPLY_TO_PRODUCT = {
        ALL: "all",
        COLLECTION: "collection",
        PRODUCT: "product",
        VARIANT: "variant"
    }

    APPLY_CONDITION_TYPE = {
        AMOUNT: "amount",
        QUANTITY: "quantity"
    }

    AUTO_ADD_TYPE = {
        FIRST_AVAILABLE: "first_available",
        SELECT_TO_ADD: "select_to_add"
    }

    GIFT_TYPE ={
        VARIANT: "variant",
        SAME_BUY: "same_buy"
    }   

    ADDED_GIFT_LOCALSTORAGE_KEY = "salepify_fg_basic_added_gift"

    constructor(
        variantMapCollections,
        template,
        rulesApplyOnAll,
        rulesApplyOnCollection,
        rulesApplyOnProduct,
        collectionsOfProduct,
        displaySetting
    ) {
        this.freeGiftBlock = document.getElementById("salepify-free-gift-block-container");
        this.claimButton = document.getElementById("salepify-free-gift-block-claim-button");
        this.giftContainer = document.getElementById("salepify-free-gift-block-content__list-gift");
        this.errorBlock = document.getElementById("salepify-free-gift-block-error");
        this.headerTitle = document.getElementById("salepify-free-gift-block-gift-title");

        this.giftSelected = new Map();
        this.variantMapCollections = variantMapCollections;
        this.errorSetTimout = null;
        this.residualGift = 0;
        this.isClaimed = false;
        this.claimedCount = 0;
        this.canClaimCount = 0
        this.giftNumber = 0;
        this.template = template;
        this.rulesApplyOnAll = rulesApplyOnAll;
        this.rulesApplyOnCollection = rulesApplyOnCollection;
        this.collectionsOfProduct = collectionsOfProduct;
        this.rulesApplyOnProduct = rulesApplyOnProduct;
        this.isShowedFirework = false;
        this.remain = 0;

        this.currency = tlFreeGiftBlockCurrencySymbol;
        this.currencyRate = 1;
        if (Shopify && Shopify.currency) {
            this.currency = Shopify.currency.active;
            this.currencyRate = Number(Shopify.currency.rate);
        }

        this.displaySetting = displaySetting && displaySetting.free_gift ? {
            container_style: {
                ...DEFAULT_DISPLAY_SETTINGS_BLOCK.container_style,
                ...displaySetting.free_gift.container_style
            },
            text_display: {
                ...DEFAULT_DISPLAY_SETTINGS_BLOCK.text_display,
                ...displaySetting.free_gift.text_display
            },
            header_style: {
                ...DEFAULT_DISPLAY_SETTINGS_BLOCK.header_style,
                ...displaySetting.free_gift.header_style
            },
            block_btn_style: {
                ...DEFAULT_DISPLAY_SETTINGS_BLOCK.block_btn_style,
                ...displaySetting.free_gift.block_btn_style
            },
            gift_item_style: {
                ...DEFAULT_DISPLAY_SETTINGS_BLOCK.gift_item_style,
                ...displaySetting.free_gift.gift_item_style
            },
            gift_icon_style: {
                ...DEFAULT_DISPLAY_SETTINGS_BLOCK.gift_icon_style,
                ...displaySetting.free_gift.gift_icon_style
            },
            cart_btn_selector: displaySetting.free_gift.cart_btn_selector || DEFAULT_DISPLAY_SETTINGS_BLOCK.cart_btn_selector
        } : DEFAULT_DISPLAY_SETTINGS_BLOCK;

        this.displayRule = this.filterRule();
        if (
            this.displayRule &&
            this.template === 'product' &&
            this.displayRule.display_type == "block"
        ) {
            if(this.displayRule.maximum_per_order === undefined){ this.displayRule.maximum_per_order = 1}
            this.applyStyle();

            this.renderGifts().then(async () => {
                await this.getRemainAmountToGetFreeGift();
                if (this.displayRule.show_free_gift_widget) {
                    this.renderGiftBox();
                    this.freeGiftBlock.style = "display: block";
                }
                tlFreeGiftBlockOverride();
            });

            this.openCartDrawAfterReload();
        } else {
            this.freeGiftBlock.style = "display: none";
            this.freeGiftBlock.innerHTML = "";
        }
    }

    applyStyle() {
        const containerStyle = this.displaySetting.container_style;
        const headerStyle = this.displaySetting.header_style;
        const claimBtnStyle = this.displaySetting.block_btn_style;
        const giftItemStyle = this.displaySetting.gift_item_style;
        const giftIConStyle = this.displaySetting.gift_icon_style;

        document.documentElement.style.setProperty('--tl-free-gift-block__container__border-color', containerStyle.border_color);
        document.documentElement.style.setProperty('--tl-free-gift-block__container__border-radius', `${containerStyle.border_radius}px`);
        document.documentElement.style.setProperty('--tl-free-gift-block__container__border-width', `${containerStyle.border_width}px`);
        document.documentElement.style.setProperty('--tl-free-gift-block__container __background-color', containerStyle.background_color);

        document.documentElement.style.setProperty('--tl-free-gift-block__header__color', headerStyle.block_color);
        document.documentElement.style.setProperty('--tl-free-gift-block__header__padding', `${headerStyle.padding}px`);

        document.documentElement.style.setProperty('--tl-free-gift-block__claim-button__padding', `${claimBtnStyle.padding}px`);
        document.documentElement.style.setProperty('--tl-free-gift-block__claim-button__background_color', claimBtnStyle.background_color);
        document.documentElement.style.setProperty('--tl-free-gift-block__claim-button__font-size', `${claimBtnStyle.font_size}px`);
        document.documentElement.style.setProperty('--tl-free-gift-block__claim-button__font-weight', claimBtnStyle.font_weight);
        document.documentElement.style.setProperty('--tl-free-gift-block__claim-button__color', claimBtnStyle.color);

        document.documentElement.style.setProperty('--tl-free-gift-block__gift-item-free-label-checkbox__color', giftItemStyle.free_label_and_checkbox_color);
        document.documentElement.style.setProperty('--tl-free-gift-block__gift-item__color', giftItemStyle.color);
        document.documentElement.style.setProperty('--tl-free-gift-block__gift-item-helptext__color', giftItemStyle.helptext_color);

        document.documentElement.style.setProperty('--tl-free-gift-block__gift-icon__icon-color', giftIConStyle.icon_color);

        document.querySelector(".salepify-free-gift-block-header-title").innerHTML = this.replaceVariables(this.displaySetting.text_display.header_title);
    }

    replaceVariables(originalString) {
        originalString = originalString.split("{{name}}").join(this.displayRule.title);
        originalString = originalString.split("{{remain}}").join(this.displayRule.apply_condition_type == this.APPLY_CONDITION_TYPE.AMOUNT ? this.formatMoney(this.remain * this.currencyRate) : this.remain);
        originalString = originalString.split("{{gift_number}}").join(this.displayRule.gift_qty);
        originalString = originalString.split("{{gift_number}}").join(`<strong>${this.giftNumber}</strong>`);

        return originalString;
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    formatMoney = function (t, e = `{{amount_with_period_and_space_separator}} ${this.currency}`) {
        function n(t, e) {
            return void 0 === t ? e : t
        }

        function o(t, e, o, i) {
            if (e = n(e, 2), o = n(o, ","), i = n(i, "."), isNaN(t) || null == t) return 0;
            var r = (t = (t / 100).toFixed(e)).split(".");
            return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (r[1] ? i + r[1] : "")
        }

        "string" == typeof t && (t = t.replace(".", ""));
        var i = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            a = e || this.money_format;
        switch (a.match(r)[1]) {
            case "amount":
                i = o(t, 2);
                break;
            case "amount_no_decimals":
                i = o(t, 0);
                break;
            case "amount_with_comma_separator":
                i = o(t, 2, ".", ",");
                break;
            case "amount_with_space_separator":
                i = o(t, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                i = o(t, 2, " ", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = o(t, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                i = o(t, 0, " ");
                break;
            case "amount_with_apostrophe_separator":
                i = o(t, 2, "'", ".")
        }
        return a.replace(r, i)
    }

    filterRule() {
        if (this.template !== "product") return;
        let rulesApplyOnProductIds = this.rulesApplyOnProduct ? Object.values(this.rulesApplyOnProduct) : [];
        let rulesApplyOnAllIds = this.rulesApplyOnAll ? Object.values(this.rulesApplyOnAll) : [];
        let rulesApplyOnCollectionIds = this.rulesApplyOnCollection ? Object.values(this.rulesApplyOnCollection) : [];
        let rulesApplyOnCollectionIncludesProduct = [];
        let displayRule;
        let listDisplayRule = [];

        rulesApplyOnCollectionIds.map((ruleData) => {
            if (ruleData.list_parents.some(parent => this.collectionsOfProduct.includes(parent.split("/")[4]))) {
                rulesApplyOnCollectionIncludesProduct.push(ruleData);
            }
        })

        if (rulesApplyOnProductIds.length) {
            listDisplayRule = this.compareRule(rulesApplyOnProductIds);
        } else if (rulesApplyOnCollectionIncludesProduct.length) {
            listDisplayRule = this.compareRule(rulesApplyOnCollectionIncludesProduct);
        } else if (rulesApplyOnAllIds.length) {
            listDisplayRule = this.compareRule(rulesApplyOnAllIds);
        }
        displayRule = this.checkActiveRule(listDisplayRule);

        if(displayRule){
            displayRule.show_free_gift_widget = (displayRule.show_free_gift_widget === undefined ? 1 : displayRule.show_free_gift_widget);
            displayRule.show_confetti_animation = (displayRule.show_confetti_animation === undefined ? 1 : displayRule.show_confetti_animation);
        }

        
        return displayRule;
    }

    checkActiveRule(listDisplayRule) {
        let displayRule;

        for (let i = 0; i < listDisplayRule.length; i++) {
            const rule = listDisplayRule[i];
            
            if(rule.start_at) {
                if(rule.end_at && (new Date(rule.end_at) > new Date())){
                    displayRule = rule;
                    break;
                }else if(new Date(rule.start_at) <= new Date()) {
                    displayRule = rule;
                    break;
                }
            }else {
                displayRule = rule;
                break;
            }
        }

        return displayRule;
    }

    compareRule(listRule) {
        let listDisplayRule = listRule.sort((a, b) => new Date(`${b.created_at}`).getTime() - new Date(`${a.created_at}`).getTime())
        return listDisplayRule
    }

    openCartDrawAfterReload() {
        if(
            window.localStorage.getItem(this.ADDED_GIFT_LOCALSTORAGE_KEY) == 'true' &&
            this.displaySetting.cart_btn_selector
        ){
            window.localStorage.setItem(this.ADDED_GIFT_LOCALSTORAGE_KEY, false);
            if(document.querySelector(this.displaySetting.cart_btn_selector)){
                setTimeout(() => {
                    document.querySelector(this.displaySetting.cart_btn_selector).click();
                }, 500)
            }
        }
    }

    increaseGiftQuanity(giftId, price) {
        if (this.residualGift > 0) {
            const giftInput = document.getElementById(`salepify-free-gift-block-input-${giftId}`);
            let value = parseInt(giftInput.value, 10);
            value = isNaN(value) ? 1 : value;
            value++;
            giftInput.value = value;
            this.giftSelected.set(giftId, value);
            this.residualGift--;
            document.getElementById(`salepify-free-gift-price-${giftId}`).innerText = this.formatMoney(price * value);
        } else {
            this.showError(this.displaySetting.text_display.error_message);
        }
        this.renderAvailableGift();
    }

    decreaseGiftQuanity(giftId, price) {
        const giftInput = document.getElementById(`salepify-free-gift-block-input-${giftId}`);
        let value = parseInt(giftInput.value, 10);
        value = isNaN(value) ? 1 : value;
        value--;
        value < 1 ? (value = 1) : this.residualGift++;
        giftInput.value = value;
        this.giftSelected.set(giftId, value);
        document.getElementById(`salepify-free-gift-price-${giftId}`).innerText = this.formatMoney(price * value);
        this.renderAvailableGift();
    }

    changeGiftQuanity(evt, giftId, price) {
        const valueBeforeChange = this.giftSelected.get(giftId);
        let value = parseInt(evt.value, 10);
        value = isNaN(value) ? 1 : value;
        value < 1 ? (value = 1) : "";

        const changeValue = value - valueBeforeChange;
        if (changeValue <= this.residualGift) {
            evt.value = value;
            this.giftSelected.set(giftId, value);
            this.residualGift -= changeValue;
            document.getElementById(`salepify-free-gift-price-${giftId}`).innerText = this.formatMoney(price * value);
        } else {
            evt.value = this.residualGift + valueBeforeChange;
            document.getElementById(`salepify-free-gift-price-${giftId}`).innerText = this.formatMoney(price * (this.residualGift + valueBeforeChange));
            this.residualGift = 0;
            this.showError(this.displaySetting.text_display.error_message);
        }
        this.renderAvailableGift();
    }

    changeGiftChecked(evt, giftId) {
        if (evt.checked) {
            if (this.residualGift > 0) {
                this.giftSelected.set(giftId, 1);
                this.residualGift--;
                document.getElementById(`salepify-free-gift-block-input-number-container-${giftId}`).style = "display: flex";
            } else {
                evt.checked = false;
                this.showError(this.displaySetting.text_display.error_message);
            }
        } else {
            //Cộng thêm giá trị gift không chọn cho residualGift
            this.residualGift += this.giftSelected.get(giftId);
            this.giftSelected.delete(giftId);
            document.getElementById(`salepify-free-gift-block-input-${giftId}`).value = 1;
            document.getElementById(`salepify-free-gift-block-input-number-container-${giftId}`).style = "display: none";
        }
        this.renderAvailableGift();
    }

    renderAvailableGift() {
        const subTextElement = document.querySelector("#salepify-free-gift-block-gift-title > .sub-text");
        if(this.residualGift > 0){
            let availableGiftHtml = this.displaySetting.text_display.choose_gift_message.replace("{{gift_remain}}", `<strong>${this.residualGift}</strong>`);
            if(this.displayRule.auto_add_gift){
                availableGiftHtml = this.displaySetting.text_display.optional_message_auto_add;
                availableGiftHtml = availableGiftHtml.replace("{{gift_number}}", `<strong>${this.giftNumber}</strong>`);
            }else{
                availableGiftHtml = availableGiftHtml.replace("{{gift_number}}", `<strong>${this.giftNumber}</strong>`);
            }
            subTextElement.innerHTML = availableGiftHtml;
        }else{
            subTextElement.innerHTML = this.displaySetting.text_display.choose_enough_gift_message;
        }
    }

    showError(message) {
        this.errorBlock.style = "display: flex;";
        this.errorBlock.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
            </svg>
            <span id="salepify-free-gift-block-error__message">${message}</span>
        `;
        this.setErrTimeOut(3000)
    }

    setErrTimeOut(times) {
        if (this.errorSetTimout) {
            clearTimeout(this.errorSetTimout)
        }

        this.errorSetTimout = setTimeout(() => {
            this.errorBlock.style = "display: none;";
            this.errorBlock.innerHTML = "";
            this.errorSetTimout = null;
        }, times)
    }

    async updateVariant() {
        try {
            await this.getRemainAmountToGetFreeGift();
            if (this.displayRule.show_free_gift_widget) {
                this.renderGiftBox();
            }
        } catch (error) {
            console.log("Error when updateVariant: ", error)
        }
    }

    getRemainAmountToGetFreeGift = async (data) =>   {
        let totalProductApplied = 0;
        let numberProductApplied = 0;
        let giftNumberInCart = 0;
        let remain = 0;
        
        let cartJsResponse = await fetch("/cart.js");
        let cartData = await cartJsResponse.json();

        if (this.displayRule.apply_to_product == this.APPLY_TO_PRODUCT.COLLECTION) {
            let listChildIds = this.displayRule.list_childs.map(a => a.id.split("/")[4]);
            cartData.items.forEach(item => {
                let itemCollections = this.variantMapCollections.get(item.id.toString())
                let isGift = false;
                item.discounts.forEach(discount => {
                    if(item.line_price == 0 && discount.title === this.displayRule.title && discount.amount == item.original_line_price){
                        isGift = true;
                    }
                });
                if(isGift){
                    if(
                        (
                            this.displayRule.gift_type === this.GIFT_TYPE.SAME_BUY && 
                            itemCollections.some(collectionId => this.displayRule.list_parents.includes(`gid://shopify/Collection/${collectionId}`))
                        ) || listChildIds.includes(item.id.toString())
                    ){
                        giftNumberInCart += item.quantity
                    }
                }else if(itemCollections && itemCollections.some(collectionId => this.displayRule.list_parents.includes(`gid://shopify/Collection/${collectionId}`))){
                    numberProductApplied += item.quantity;
                    totalProductApplied += item.presentment_price * item.quantity * 100 
                }
            });
            if (data) {
                let itemCollections = this.variantMapCollections.get(data.id.toString());
                if(data.isGift){
                    giftNumberInCart += data.quantity
                }else if(itemCollections && itemCollections.some(collectionId => this.displayRule.list_parents.includes(`gid://shopify/Collection/${collectionId}`))){
                    numberProductApplied += data.quantity;
                    totalProductApplied += data.quantity * data.presentment_price * 100 ;
                }
            }
        } else {
            let listChildIds = this.displayRule.list_childs.map(a => a.id.split("/")[4]);
            cartData.items.forEach(item => {
                let isGift = false;
                item.discounts.forEach(discount => {
                    if(item.line_price == 0 && discount.title === this.displayRule.title && discount.amount == item.original_line_price){
                        isGift = true;
                    }
                });

                if(isGift){
                    if(listChildIds.includes(item.id.toString())){
                        giftNumberInCart += item.quantity;
                    }
                }else if(this.displayRule.list_parents.includes(item.id.toString())){
                    numberProductApplied += item.quantity;
                    totalProductApplied += item.presentment_price * item.quantity * 100;
                }
            });
            if (data) {
                if(data.isGift){
                    giftNumberInCart += data.quantity;
                }else if(this.displayRule.list_parents.includes(data.id.toString())){
                    numberProductApplied += data.quantity;
                    totalProductApplied += data.quantity * data.presentment_price * 100;
                }
            }
        }

        let canClaimCount = 0; 
        if(this.displayRule.apply_condition_type === this.APPLY_CONDITION_TYPE.AMOUNT) {
            canClaimCount = Math.floor(totalProductApplied / (this.displayRule.apply_condition_value * 100 * this.currencyRate));
        }else{
            canClaimCount = Math.floor(numberProductApplied / (this.displayRule.apply_condition_value));
        }

        let appliedCount = Math.floor(giftNumberInCart / this.displayRule.gift_qty);
        let targetClaimCount = 0;
        if(this.displayRule.maximum_per_order ){
            if(appliedCount >= this.displayRule.maximum_per_order){
                appliedCount = this.displayRule.maximum_per_order;
                targetClaimCount = this.displayRule.maximum_per_order;
                if(appliedCount >= canClaimCount){
                    this.claimedCount = canClaimCount;
                    this.canClaimCount = appliedCount;
                }else{
                    this.claimedCount = appliedCount;
                    this.canClaimCount = appliedCount;
                }
            }else {
                if(canClaimCount >= this.displayRule.maximum_per_order){
                    canClaimCount = this.displayRule.maximum_per_order;
                    targetClaimCount = canClaimCount;
                    this.claimedCount = appliedCount;
                    this.canClaimCount = canClaimCount;
                }else{
                    if(appliedCount > canClaimCount){
                        targetClaimCount = appliedCount;
                        this.claimedCount = appliedCount;
                        this.canClaimCount = appliedCount;
                    }else if(appliedCount < canClaimCount){
                        targetClaimCount = canClaimCount;
                        this.claimedCount = appliedCount;
                        this.canClaimCount = canClaimCount;
                    }else {
                        targetClaimCount = canClaimCount + 1;
                        this.claimedCount = canClaimCount;
                        this.canClaimCount = canClaimCount;
                    }
                }
            }
        }else{
            if(appliedCount > canClaimCount){
                targetClaimCount = appliedCount;
                this.claimedCount = appliedCount;
                this.canClaimCount = appliedCount;
            }else if(appliedCount < canClaimCount){
                targetClaimCount = canClaimCount;
                this.claimedCount = appliedCount;
                this.canClaimCount = canClaimCount;
            }else {
                targetClaimCount = canClaimCount + 1;
                this.claimedCount = canClaimCount;
                this.canClaimCount = canClaimCount;
            }
        }

        if(this.displayRule.apply_condition_type === this.APPLY_CONDITION_TYPE.AMOUNT) {
            remain = (this.displayRule.apply_condition_value * 100 * this.currencyRate * targetClaimCount - totalProductApplied) ;
        }else{
            remain = (this.displayRule.apply_condition_value * targetClaimCount - numberProductApplied);
        }

        if(targetClaimCount === this.claimedCount){
            this.isClaimed = true
        }else{
            this.isClaimed = false
        }

        this.giftNumber = targetClaimCount * this.displayRule.gift_qty;
        
        if(this.displayRule.auto_add_gift){
            this.residualGift = 0;
        }else {
            this.residualGift = this.giftNumber - giftNumberInCart;
            Array.from(this.giftSelected).map(([giftId, quantity])=> {
                this.residualGift -= quantity
            })
        }
        this.remain = remain > 0 ? remain : 0;
    }

    getGiftHtml (variant, product, additionClass, quantity = 1) {
        return `
            <div class="salepify-free-gift-block-gift ${additionClass}">
                <div class="salepify-free-gift-block-checkbox-wrapper">
                    <input 
                        class="inp-cbx" 
                        id="salepify-free-gift-block-checkbox-${variant.id}" 
                        type="checkbox"
                        onchange="window.tlFreeGiftBlock.changeGiftChecked(this, ${variant.id})"/>
                    <label class="cbx" for="salepify-free-gift-block-checkbox-${variant.id}">
                        <span>
                            <svg width="12px" height="10px">
                                <use xlink:href="#check-4"></use>
                            </svg>
                        </span>
                    </label>
                    <svg class="inline-svg">
                        <symbol id="check-4" viewbox="0 0 12 10">
                            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                        </symbol>
                    </svg>
                </div>
                <div class="salepify-free-gift-block-gift__info"> 
                    <a href="/products/${product.handle}?variant=${variant.id}" target="_blank">
                        <img src="${(variant.featured_image && variant.featured_image.src) ? variant.featured_image.src : product.images[0]}" /> 
                    </a>
                    <div> 
                        <a href="/products/${product.handle}?variant=${variant.id}" class="salepify-free-gift-block-gift__title" target="_blank">  
                            ${product.title} ${variant.title === "Default Title" ? "" : "- " + variant.title}
                        </a>
                        <div class="salepify-free-gift-block-gift__price">  
                            <span class="free-lable font-weight-700">${this.displaySetting.text_display.free_text_content}</span>
                            <span class="salepify-free-gift-block-gift-compare-price" id="salepify-free-gift-price-${variant.id}">${this.formatMoney(variant.price * quantity)}</span>
                        </div>

                        <div class="salepify-free-gift-block-badge-qty">
                            x${quantity}
                        </div>

                        <div class="salepify-free-gift-block-input-number-container" id="salepify-free-gift-block-input-number-container-${variant.id}">
                            <button type="button" onclick="window.tlFreeGiftBlock.decreaseGiftQuanity(${variant.id}, ${variant.price})" class="salepify-free-gift-block-input-number-container__decrease">-</button>
                            <input 
                                type="number" 
                                class="salepify-free-gift-block-input-number" 
                                id="salepify-free-gift-block-input-${variant.id}"  
                                min="1" 
                                step="1" 
                                value="1" 
                                onchange="window.tlFreeGiftBlock.changeGiftQuanity(this, ${variant.id}, ${variant.price})"/>
                            <button type="button" onclick="window.tlFreeGiftBlock.increaseGiftQuanity(${variant.id}, ${variant.price})" class="salepify-free-gift-block-input-number-container__increase">+</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    async renderGifts() {
        let uniqueGiftHandle = new Set();
        let listVariantGift = [];

        this.displayRule.list_childs.map((child) => {
            uniqueGiftHandle.add(child.handle);
            listVariantGift.push(child.id);
        })

        uniqueGiftHandle = Array.from(uniqueGiftHandle);

        const productGiftDataReq = (this.displayRule.gift_type === this.GIFT_TYPE.SAME_BUY && this.displayRule.apply_to_product === this.APPLY_TO_PRODUCT.COLLECTION) ? [] :
            await Promise.all(uniqueGiftHandle.map(handle => fetch(window.Shopify.routes.root + `products/${handle}.js`)));

        const productGiftDataRes = await Promise.all(productGiftDataReq.map(req => req.json()));

        let listGiftHtml = "";
        if (this.displayRule.auto_add_gift) {
            if (this.displayRule.auto_add_type == this.AUTO_ADD_TYPE.SELECT_TO_ADD) {
                listVariantGift = Object.keys(this.displayRule.gift_auto_add_map_qty);

                productGiftDataRes.map(product => {
                    product.variants.map(variant => {
                        const globalId = "gid://shopify/ProductVariant/" + variant.id;
                        if (listVariantGift.includes(globalId)) {
                            const addQty = this.displayRule.gift_auto_add_map_qty[globalId];
                            listGiftHtml += this.getGiftHtml(variant, product, "salepify-free-gift-block-gift--with-qty-badge", addQty);
                            this.giftSelected.set(variant.id, addQty);
                        }
                    })
                })
            } else {
                let hasAvailableGift = false
                for (let i = 0; i < productGiftDataRes.length; i++) {
                    const product = productGiftDataRes[i];
                    if (!hasAvailableGift) {
                        for (let j = 0; j < product.variants.length; j++) {
                            const variant = product.variants[j];
                            if (listVariantGift.includes("gid://shopify/ProductVariant/" + variant.id) && variant.available) {
                                this.giftSelected.set(variant.id, this.displayRule.gift_qty);
                                listGiftHtml += this.getGiftHtml(variant, product, "salepify-free-gift-block-gift--with-qty-badge", this.displayRule.gift_qty);
                                hasAvailableGift = true;
                                break;
                            }
                        }
                    } else {
                        break;
                    }
                }
            }
            this.residualGift = 0;
        } else {

            if(this.displayRule.gift_type === this.GIFT_TYPE.SAME_BUY){
                if(this.displayRule.apply_to_product === this.APPLY_TO_PRODUCT.COLLECTION){
                    this.displayRule.list_childs.map(collection => {
                        listGiftHtml += `<a href="/collections/${collection.handle}" target="_blank">${collection.title}</a>`
                    })
                }else {
                    productGiftDataRes.map(product => {
                        product.variants.map(variant => {
                            if (listVariantGift.includes("gid://shopify/ProductVariant/" + variant.id)) {
                                listGiftHtml += this.getGiftHtml(variant, product, "");
                            }
                        })
                    })
                }
            }else {
                productGiftDataRes.map(product => {
                    product.variants.map(variant => {
                        if (listVariantGift.includes("gid://shopify/ProductVariant/" + variant.id)) {
                            listGiftHtml += this.getGiftHtml(variant, product, "salepify-free-gift-block-gift--with-qty-selector");
                        }
                    })
                })
            }
        }

        this.giftContainer.innerHTML = listGiftHtml;
    }

    async handleClaimGifts() {
        this.claimButton.classList.add("salepify-free-gift-block-claim-button--loading");
        this.claimButton.innerText = "";
        let claimCount = 1;
        if(this.displayRule.auto_add_gift){
            claimCount = (this.canClaimCount - this.claimedCount)
        }

        let formData = {
            'items': Array.from(this.giftSelected).map(([giftId, quantity])=> {
                const qty = quantity * claimCount;
                return {
                    "id": giftId,
                    "quantity": qty
                }
            })
        }

        if(this.giftSelected.size > 0 && (this.residualGift <= 0 || this.displayRule.auto_add_gift)){
            
            let addToCartRes = await fetch(window.Shopify.routes.root + 'cart/add.js?app=salepify', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })

            let addToCartData = await addToCartRes.json();

            if (addToCartData.items) {
                this.claimButton.disabled = true;
                if (!this.displayRule.auto_add_gift) {
                    window.location.reload();
                }else{
                    if(this.displayRule.maximum_per_order && this.displayRule.maximum_per_order <= this.claimedCount){
                        this.isClaimed = true;
                    }else{
                        await this.getRemainAmountToGetFreeGift();
                    }
                    this.renderGiftBox();
                }
            } else {
                this.showError(this.displaySetting.text_display.error_message);
            }
        } else {
            this.showError(this.displaySetting.text_display.warning_message)
        }

        this.claimButton.classList.remove("salepify-free-gift-block-claim-button--loading");
        this.claimButton.innerText = this.replaceVariables(this.displaySetting.text_display.claim_button);
    }

    renderGiftBox() {
        if (!this.displayRule.show_free_gift_widget) return;

        const freeGiftBoxIconContainer = document.querySelector("#salepify-free-gift-block-gift-icon");
        const freeGiftBoxIcon = document.querySelector("#salepify-free-gift-block-gift-icon svg");
    
        freeGiftBoxIcon.style.display = this.displaySetting.gift_icon_style.is_icon_displayed ? "block" : "none";
        freeGiftBoxIconContainer.style.backgroundImage = this.displaySetting.gift_icon_style.is_icon_displayed ? "none" : `url(${this.displaySetting.gift_icon_style.free_gift_image.url})`;
        freeGiftBoxIconContainer.style.height = this.displaySetting.gift_icon_style.is_icon_displayed ? "auto" : "50px";
        freeGiftBoxIconContainer.style.marginRight = this.displaySetting.gift_icon_style.is_icon_displayed ? "0" : "10px";
    
        const listCheckBoxGift = !this.displayRule.auto_add_gift ?
            document.querySelectorAll("input[id^=salepify-free-gift-block-checkbox-]") : []

        const textDisplaySetting = this.displaySetting.text_display;
        this.claimButton.innerText = this.replaceVariables(textDisplaySetting.claim_button);
        if (this.remain <= 0) {
            if (this.isClaimed) {
                this.headerTitle.innerHTML = `
                    <span class="header-title">${this.replaceVariables(textDisplaySetting.achieve_title)}</span>
                    <span class="sub-text">${this.displaySetting.text_display.claim_all_gift_message}</span>
                `;
                this.claimButton.disabled = true;
                this.claimButton.innerHTML = this.displaySetting.text_display.claimed_button;
                listCheckBoxGift.forEach(ele => {
                    ele.parentNode.style.display = "none";
                });
            } else {
                if (this.displayRule.gift_type !== this.GIFT_TYPE.SAME_BUY){
                    listCheckBoxGift.forEach(ele => {
                        ele.disabled = false;
                        ele.parentNode.style.display = "block";
                    });
                    this.claimButton.disabled = false;
                    this.claimButton.addEventListener("click", function () {
                        window.tlFreeGiftBlock.handleClaimGifts()
                    })
                }

                let availableGiftHtml = this.displaySetting.text_display.choose_gift_message.replace("{{gift_remain}}", `<strong>${this.residualGift}</strong>`);
                if(this.displayRule.auto_add_gift){
                    availableGiftHtml = this.displaySetting.text_display.optional_message_auto_add;
                    availableGiftHtml = availableGiftHtml.replace("{{gift_number}}", `<strong>${this.giftNumber}</strong>`);
                }else{
                    availableGiftHtml = availableGiftHtml.replace("{{gift_number}}", `<strong>${this.giftNumber}</strong>`);
                }
                this.headerTitle.innerHTML = `
                    <span class="header-title">${this.replaceVariables(textDisplaySetting.achieve_title)}</span>
                    <span class="sub-text">${availableGiftHtml}</span>
                `;

                if (!this.isShowedFirework) {
                    const firework = new TLFreeGiftBlockFireworks();
                    if (this.displayRule.show_confetti_animation) {
                        firework.partyTime();
                    }

                    this.isShowedFirework = true
                }
            }

            if (!this.displayRule.auto_add_gift) {
                this.claimButton.style.display = "block";
            }
        } else {
            listCheckBoxGift.forEach(ele => {
                const giftId = ele.id.replace("salepify-free-gift-block-checkbox-", "");
                document.getElementById(`salepify-free-gift-block-input-${giftId}`).value = 1;
                document.getElementById(`salepify-free-gift-block-input-number-container-${giftId}`).style = "display: none";

                ele.disabled = true;
                ele.checked = false;
                this.giftSelected = new Map();
            });

            this.claimButton.style.display = "none";
            this.claimButton.removeEventListener("click", function () {
                window.tlFreeGiftBlock.handleClaimGifts()
            });
            this.isShowedFirework = false;

            if (this.displayRule.apply_condition_type == this.APPLY_CONDITION_TYPE.AMOUNT) {
                let descText = this.replaceVariables(this.displaySetting.text_display.upsell_message_amount);
                descText = descText.replace("{{product}}", `<strong>${tlFreeGiftBlockCurrentProductTitle}<strong>`);
                descText = descText.replace("{{remain}}", `<strong>${this.formatMoney(this.displayRule.apply_condition_value * 100)}</strong>`)
                this.headerTitle.innerHTML = `
                    <span class="header-title">${this.replaceVariables(textDisplaySetting.remain_title)}</span>
                    <span class="sub-text">${descText}</span>
                `;
            } else {
                let descText = this.replaceVariables(this.displaySetting.text_display.upsell_message_qty);
                descText = descText.replace("{{product}}", `<strong>${tlFreeGiftBlockCurrentProductTitle}<strong>`);
                descText = descText.replace("{{remain}}", `<strong>${this.displayRule.apply_condition_value}</strong>`)
                this.headerTitle.innerHTML = `
                    <span class="header-title">${this.replaceVariables(textDisplaySetting.remain_title)}</span>
                    <span class="sub-text">${descText}</span>
                `;
            }
        }
        // With the gift option the same as the customer buy, the claim button will be hidden.
        if (this.displayRule.gift_type === this.GIFT_TYPE.SAME_BUY) this.claimButton.style = "display: none !important";
    }
}

const tlFreeGiftBlockOverride = () => {
    if (!window || !window.Shopify) return;

    const CartEvents = {
        add: "TLFREEGIFT:add",
        update: "TLFREEGIFT:update",
        change: "TLFREEGIFT:change",
        clear: "TLFREEGIFT:clear",
        mutate: "TLFREEGIFT:mutate",
    };

    const ShopifyCartURLs = [
        "/cart/add",
        "/cart/update",
        "/cart/change",
        "/cart/clear",
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
        "/cart/add.js?upcart=1&opens_cart=maybe"
    ];

    function isShopifyCartURL(url) {
        if(url instanceof URL) url = url.href;
        if(typeof url == "object" && url.url) url = url.url;
        if (!url || url.includes("app=salepify")) return false;
        
        try {
            let path = url.split("/").pop();
                path = path.split("?").shift();
            return ShopifyCartURLs.includes(`/cart/${path}`);
        } catch (e) {
            console.log("Not a normal URL: ", e)
            return false;
        }
    }

    function updateType(url) {
        if (!url || url.includes("app=salepify")) return false;
        if (url.includes("cart/add")) {
            return "add";
        } else if (url.includes("cart/update")) {
            return "update";
        } else if (url.includes("cart/change")) {
            return "change";
        } else if (url.includes("cart/clear")) {
            return "clear";
        } else return false;
    }

    function dispatchEvent(url, detail) {
        if (typeof detail === "string") {
            try {
                detail = JSON.parse(detail);
            } catch (e) {
                console.log("Error: ", e)
            }
        }

        const type = updateType(url);
        switch (type) {
            case "add":
                window.dispatchEvent(new CustomEvent(CartEvents.add, {detail}));
                break;
            case "update":
                window.dispatchEvent(new CustomEvent(CartEvents.update, {detail}));
                break;
            case "clear":
                window.dispatchEvent(new CustomEvent(CartEvents.clear, {detail}));
                break;
            case "change":
                window.dispatchEvent(new CustomEvent(CartEvents.change, {detail}));
                break;
            default:
                break;
        }
    }

    function XHROverride() {
        if (!window.XMLHttpRequest) return;

        const originalOpen = window.XMLHttpRequest.prototype.open;
        window.XMLHttpRequest.prototype.open = function () {
            const url = arguments[1];
            if (isShopifyCartURL(url)) {
                this.addEventListener("load", async function () {
                    if (window.tlFreeGiftBlock.isJson(this.response)) {
                        const res = JSON.parse(this.response)
                        if(res.id || res.items_added.length){
                            await window.tlFreeGiftBlock.getRemainAmountToGetFreeGift()
                            if (window.tlFreeGiftBlock.displayRule.show_free_gift_widget) {
                                window.tlFreeGiftBlock.renderGiftBox();
                            }
                        }
                        
                        if(
                            window.tlFreeGiftBlock.displayRule.auto_add_gift &&
                            window.tlFreeGiftBlock.claimedCount < window.tlFreeGiftBlock.canClaimCount
                        ){
                           
                            await window.tlFreeGiftBlock.handleClaimGifts();
                            window.localStorage.setItem(window.tlFreeGiftBlock.ADDED_GIFT_LOCALSTORAGE_KEY, true)
                            window.location.reload();
                        }
                    } else {
                        dispatchEvent(url, this.response);
                    }
                });
                return originalOpen.apply(this, arguments);
            } else {
                return originalOpen.apply(this, arguments);
            }
        };
    }

    function fetchOverride() {
        if (!window.fetch || typeof window.fetch !== "function") return;
        const originalFetch = window.fetch;
        window.fetch = async function () {
            const [resource, config] = [...arguments];
            if (isShopifyCartURL(resource)) {
                if(
                    window.tlFreeGiftBlock.displayRule && 
                    !window.tlFreeGiftBlock.isClaimed &&
                    config &&
                    config.body
                ) {
                    if (resource.includes('add')) {
                        if (config.body instanceof FormData && config.body.getAll("id")) {
                            const variantId = String(config.body.getAll("id"));
                            let qty = Number(config.body.getAll("quantity"));
                                qty = qty ? qty : 1;
                            let presentmentPrice = tlFreeGiftBlockVariantIdMapData.get(variantId).price / 100;

                            let data = {
                                id: variantId,
                                quantity: qty,
                                presentment_price: presentmentPrice
                            }
                            await window.tlFreeGiftBlock.getRemainAmountToGetFreeGift(data)
                            if (window.tlFreeGiftBlock.displayRule.show_free_gift_widget) {
                                window.tlFreeGiftBlock.renderGiftBox();
                            }
                            if(
                                window.tlFreeGiftBlock.displayRule.auto_add_gift &&
                                window.tlFreeGiftBlock.claimedCount < window.tlFreeGiftBlock.canClaimCount
                            ){
                               
                                await window.tlFreeGiftBlock.handleClaimGifts();
                            }
                        }else {
                            let variantId = null;
                            let qty = 1;
                            const allRequestBody = config.body.split("&");
                            if (allRequestBody.length) {
                                allRequestBody.map(param => {
                                    if (param) {
                                        const paramArray = param.split('=');
                                        if (paramArray.length > 1) {
                                            if (paramArray[0] === "id") {
                                                variantId = paramArray[1];
                                            } else if (paramArray[0] === "quantity") {
                                                qty = paramArray[1] ? Number(paramArray[1]) : 1;
                                            }
                                        } else if (window.tlFreeGiftBlock.isJson(param)) {
                                            const paramObj = JSON.parse(param);
                                            if(paramObj.id){
                                                variantId = paramObj.id;
                                                qty = paramObj.quantity ? Number(paramObj.quantity) : 1;
                                            }else if(paramObj.items){
                                                for (let i = 0; i < paramObj.items.length; i++) {
                                                    const item = paramObj.items[i];
                                                    let itemId = String(item.id)
                                                    if(tlFreeGiftBlockVariantIdOfCurrentProduct.includes(itemId)){
                                                        variantId = itemId;
                                                        qty = item.quantity ? Number(item.quantity) : 1;
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                })
                            }

                            if (variantId) {
                                let presentmentPrice = tlFreeGiftBlockVariantIdMapData.get(variantId)?.price ? tlFreeGiftBlockVariantIdMapData.get(variantId).price / 100 : 0;

                                let data = {
                                    id: variantId,
                                    quantity: qty,
                                    presentment_price: presentmentPrice
                                }
                                await window.tlFreeGiftBlock.getRemainAmountToGetFreeGift(data)
                                if (window.tlFreeGiftBlock.displayRule.show_free_gift_widget) {
                                    window.tlFreeGiftBlock.renderGiftBox();
                                }

                                if(
                                    window.tlFreeGiftBlock.displayRule.auto_add_gift &&
                                    window.tlFreeGiftBlock.claimedCount < window.tlFreeGiftBlock.canClaimCount
                                ){
                                   
                                    await window.tlFreeGiftBlock.handleClaimGifts();
                                }
                            }
                        }
                    }else if(window.tlFreeGiftBlock.displayRule.auto_add_gift){
                        const cartDataReq = await originalFetch('/cart.js', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        });
                        const cartDataRes = await cartDataReq.json();
                        let items = JSON.parse(JSON.stringify(cartDataRes.items));
                        let isGift = false;
                        if (items.length) {
                            const bodyArgument = JSON.parse(config.body);
                            let lineChangeIndex = 0;
                            if(bodyArgument.line){
                                lineChangeIndex = Number(bodyArgument.line) - 1;
                            }else {
                                items.map((item, index) => {
                                    if(item.key === bodyArgument.id){
                                        lineChangeIndex =  index;
                                    }
                                });
                            }
                            const itemChangeData = items[lineChangeIndex]
                            const newLineQty = Number(bodyArgument.quantity);
                            const variantChangeId = itemChangeData.id;
                            let diffQty = 0;
                            let presentmentPrice = 0;

                            let discountTitles = itemChangeData.discounts.map(a => a.title);
                            if(itemChangeData.line_price == 0 && discountTitles.includes(window.tlFreeGiftBlock.displayRule.title)){
                                isGift = true;
                            }

                            if(newLineQty > 0){
                                diffQty = newLineQty - itemChangeData.quantity;
                                presentmentPrice = itemChangeData.presentment_price
                                itemChangeData.quantity = newLineQty;
                            }else {
                                diffQty = - itemChangeData.quantity;
                                presentmentPrice = itemChangeData.presentment_price
                                items.splice(lineChangeIndex, 1)
                            }
                            
                            let data = {
                                isGift: isGift,
                                id: variantChangeId,
                                quantity: diffQty,
                                presentment_price: presentmentPrice
                            } 
                            await window.tlFreeGiftBlock.getRemainAmountToGetFreeGift(data)
                            if (window.tlFreeGiftBlock.displayRule.show_free_gift_widget) {
                                window.tlFreeGiftBlock.renderGiftBox();
                            }

                            if(window.tlFreeGiftBlock.claimedCount < window.tlFreeGiftBlock.canClaimCount){
                                await window.tlFreeGiftBlock.handleClaimGifts();
                                const cartDataReq = await originalFetch('/cart.js', {
                                    method: 'GET',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                });
                                const cartDataRes = await cartDataReq.json();

                                const dataUpdate = {
                                    line: String(lineChangeIndex + 1),
                                    quantity: String(newLineQty)
                                }

                                cartDataRes.items.map((item, index) => {
                                    if(item.id == variantChangeId){
                                        dataUpdate.line = String(index + 1);
                                        dataUpdate.quantity = String(item.quantity + diffQty);
                                    }
                                })

                                arguments[1].body = JSON.stringify({
                                    ...bodyArgument,
                                    ...dataUpdate
                                })
                            }
                        }
                    }
                }

                const response = originalFetch.apply(this, arguments)

                response.then((res) => {
                    res
                        .clone()
                        .json()
                        .then((data) => dispatchEvent(res.url, data));
                });
                return response;
            } else {
                return originalFetch(...arguments)
            }

        };
    }

    if (
        window.tlFreeGiftBlock.displayRule &&
        window.tlFreeGiftBlock.template === 'product' &&
        window.tlFreeGiftBlock.displayRule.display_type == "block"
    ){
        window.addEventListener('TLFREEGIFT:add', (event) => {
            window.tlFreeGiftBlock.updateVariant();
        })

        window.addEventListener('TLFREEGIFT:change', (event) => {
            window.tlFreeGiftBlock.updateVariant();
        })

        fetchOverride();
        XHROverride();
    }
};

!function (t, e) {
    !function t(e, n, a, i) {
        var o = !!(e.Worker && e.Blob && e.Promise && e.OffscreenCanvas && e.OffscreenCanvasRenderingContext2D && e.HTMLCanvasElement && e.HTMLCanvasElement.prototype.transferControlToOffscreen && e.URL && e.URL.createObjectURL);

        function r() {
        }

        function l(t) {
            var a = n.exports.Promise, i = void 0 !== a ? a : e.Promise;
            return "function" == typeof i ? new i(t) : (t(r, r), null)
        }

        var c, s, u, d, f, h, g, m,
            b = (u = Math.floor(1e3 / 60), d = {}, f = 0, "function" == typeof requestAnimationFrame && "function" == typeof cancelAnimationFrame ? (c = function (t) {
                var e = Math.random();
                return d[e] = requestAnimationFrame((function n(a) {
                    f === a || f + u - 1 < a ? (f = a, delete d[e], t()) : d[e] = requestAnimationFrame(n)
                })), e
            }, s = function (t) {
                d[t] && cancelAnimationFrame(d[t])
            }) : (c = function (t) {
                return setTimeout(t, u)
            }, s = function (t) {
                return clearTimeout(t)
            }), {frame: c, cancel: s}), v = (m = {}, function () {
                if (h) return h;
                if (!a && o) {
                    var e = ["var CONFETTI, SIZE = {}, module = {};", "(" + t.toString() + ")(this, module, true, SIZE);", "onmessage = function(msg) {", "  if (msg.data.options) {", "    CONFETTI(msg.data.options).then(function () {", "      if (msg.data.callback) {", "        postMessage({ callback: msg.data.callback });", "      }", "    });", "  } else if (msg.data.reset) {", "    CONFETTI.reset();", "  } else if (msg.data.resize) {", "    SIZE.width = msg.data.resize.width;", "    SIZE.height = msg.data.resize.height;", "  } else if (msg.data.canvas) {", "    SIZE.width = msg.data.canvas.width;", "    SIZE.height = msg.data.canvas.height;", "    CONFETTI = module.exports.create(msg.data.canvas);", "  }", "}"].join("\n");
                    try {
                        h = new Worker(URL.createObjectURL(new Blob([e])))
                    } catch (t) {
                        return void 0 !== typeof console && "function" == typeof console.warn && console.warn("🎊 Could not load worker", t), null
                    }
                    !function (t) {
                        function e(e, n) {
                            t.postMessage({options: e || {}, callback: n})
                        }

                        t.init = function (e) {
                            var n = e.transferControlToOffscreen();
                            t.postMessage({canvas: n}, [n])
                        }, t.fire = function (n, a, i) {
                            if (g) return e(n, null), g;
                            var o = Math.random().toString(36).slice(2);
                            return g = l((function (a) {
                                function r(e) {
                                    e.data.callback === o && (delete m[o], t.removeEventListener("message", r), g = null, i(), a())
                                }

                                t.addEventListener("message", r), e(n, o), m[o] = r.bind(null, {data: {callback: o}})
                            }))
                        }, t.reset = function () {
                            for (var e in t.postMessage({reset: !0}), m) m[e](), delete m[e]
                        }
                    }(h)
                }
                return h
            }), y = {
                particleCount: 50,
                angle: 90,
                spread: 45,
                startVelocity: 45,
                decay: .9,
                gravity: 1,
                drift: 0,
                ticks: 200,
                x: .5,
                y: .5,
                shapes: ["square", "circle"],
                zIndex: 100,
                colors: ["#26ccff", "#a25afd", "#ff5e7e", "#88ff5a", "#fcff42", "#ffa62d", "#ff36ff"],
                disableForReducedMotion: !1,
                scalar: 1
            };

        function p(t, e, n) {
            return function (t, e) {
                return e ? e(t) : t
            }(t && null != t[e] ? t[e] : y[e], n)
        }

        function M(t) {
            return t < 0 ? 0 : Math.floor(t)
        }

        function w(t) {
            return parseInt(t, 16)
        }

        function x(t) {
            return t.map(C)
        }

        function C(t) {
            var e = String(t).replace(/[^0-9a-f]/gi, "");
            return e.length < 6 && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), {
                r: w(e.substring(0, 2)),
                g: w(e.substring(2, 4)),
                b: w(e.substring(4, 6))
            }
        }

        function k(t) {
            t.width = document.documentElement.clientWidth, t.height = document.documentElement.clientHeight
        }

        function I(t) {
            var e = t.getBoundingClientRect();
            t.width = e.width, t.height = e.height
        }

        function T(t, e, n, o, r) {
            var c, s, u = e.slice(), d = t.getContext("2d"), f = l((function (e) {
                function l() {
                    c = s = null, d.clearRect(0, 0, o.width, o.height), r(), e()
                }

                c = b.frame((function e() {
                    !a || o.width === i.width && o.height === i.height || (o.width = t.width = i.width, o.height = t.height = i.height), o.width || o.height || (n(t), o.width = t.width, o.height = t.height), d.clearRect(0, 0, o.width, o.height), (u = u.filter((function (t) {
                        return function (t, e) {
                            e.x += Math.cos(e.angle2D) * e.velocity + e.drift, e.y += Math.sin(e.angle2D) * e.velocity + e.gravity, e.wobble += .1, e.velocity *= e.decay, e.tiltAngle += .1, e.tiltSin = Math.sin(e.tiltAngle), e.tiltCos = Math.cos(e.tiltAngle), e.random = Math.random() + 5, e.wobbleX = e.x + 10 * e.scalar * Math.cos(e.wobble), e.wobbleY = e.y + 10 * e.scalar * Math.sin(e.wobble);
                            var n = e.tick++ / e.totalTicks, a = e.x + e.random * e.tiltCos,
                                i = e.y + e.random * e.tiltSin, o = e.wobbleX + e.random * e.tiltCos,
                                r = e.wobbleY + e.random * e.tiltSin;
                            return t.fillStyle = "rgba(" + e.color.r + ", " + e.color.g + ", " + e.color.b + ", " + (1 - n) + ")", t.beginPath(), "circle" === e.shape ? t.ellipse ? t.ellipse(e.x, e.y, Math.abs(o - a) * e.ovalScalar, Math.abs(r - i) * e.ovalScalar, Math.PI / 10 * e.wobble, 0, 2 * Math.PI) : function (t, e, n, a, i, o, r, l, c) {
                                t.save(), t.translate(e, n), t.rotate(o), t.scale(a, i), t.arc(0, 0, 1, r, l, c), t.restore()
                            }(t, e.x, e.y, Math.abs(o - a) * e.ovalScalar, Math.abs(r - i) * e.ovalScalar, Math.PI / 10 * e.wobble, 0, 2 * Math.PI) : (t.moveTo(Math.floor(e.x), Math.floor(e.y)), t.lineTo(Math.floor(e.wobbleX), Math.floor(i)), t.lineTo(Math.floor(o), Math.floor(r)), t.lineTo(Math.floor(a), Math.floor(e.wobbleY))), t.closePath(), t.fill(), e.tick < e.totalTicks
                        }(d, t)
                    }))).length ? c = b.frame(e) : l()
                })), s = l
            }));
            return {
                addFettis: function (t) {
                    return u = u.concat(t), f
                }, canvas: t, promise: f, reset: function () {
                    c && b.cancel(c), s && s()
                }
            }
        }

        function E(t, n) {
            var a, i = !t, r = !!p(n || {}, "resize"), c = p(n, "disableForReducedMotion", Boolean),
                s = o && !!p(n || {}, "useWorker") ? v() : null, u = i ? k : I,
                d = !(!t || !s) && !!t.__confetti_initialized,
                f = "function" == typeof matchMedia && matchMedia("(prefers-reduced-motion)").matches;

            function h(e, n, i) {
                for (var o, r, l, c, s, d = p(e, "particleCount", M), f = p(e, "angle", Number), h = p(e, "spread", Number), g = p(e, "startVelocity", Number), m = p(e, "decay", Number), b = p(e, "gravity", Number), v = p(e, "drift", Number), y = p(e, "colors", x), w = p(e, "ticks", Number), C = p(e, "shapes"), k = p(e, "scalar"), I = function (t) {
                    var e = p(t, "origin", Object);
                    return e.x = p(e, "x", Number), e.y = p(e, "y", Number), e
                }(e), E = d, S = [], F = t.width * I.x, N = t.height * I.y; E--;) S.push((o = {
                    x: F,
                    y: N,
                    angle: f,
                    spread: h,
                    startVelocity: g,
                    color: y[E % y.length],
                    shape: C[(c = 0, s = C.length, Math.floor(Math.random() * (s - c)) + c)],
                    ticks: w,
                    decay: m,
                    gravity: b,
                    drift: v,
                    scalar: k
                }, r = void 0, l = void 0, r = o.angle * (Math.PI / 180), l = o.spread * (Math.PI / 180), {
                    x: o.x,
                    y: o.y,
                    wobble: 10 * Math.random(),
                    velocity: .5 * o.startVelocity + Math.random() * o.startVelocity,
                    angle2D: -r + (.5 * l - Math.random() * l),
                    tiltAngle: Math.random() * Math.PI,
                    color: o.color,
                    shape: o.shape,
                    tick: 0,
                    totalTicks: o.ticks,
                    decay: o.decay,
                    drift: o.drift,
                    random: Math.random() + 5,
                    tiltSin: 0,
                    tiltCos: 0,
                    wobbleX: 0,
                    wobbleY: 0,
                    gravity: 3 * o.gravity,
                    ovalScalar: .6,
                    scalar: o.scalar
                }));
                return a ? a.addFettis(S) : (a = T(t, S, u, n, i)).promise
            }

            function g(n) {
                var o = c || p(n, "disableForReducedMotion", Boolean), g = p(n, "zIndex", Number);
                if (o && f) return l((function (t) {
                    t()
                }));
                i && a ? t = a.canvas : i && !t && (t = function (t) {
                    var e = document.createElement("canvas");
                    return e.style.position = "fixed", e.style.top = "0px", e.style.left = "0px", e.style.pointerEvents = "none", e.style.zIndex = t, e
                }(g), document.body.appendChild(t)), r && !d && u(t);
                var m = {width: t.width, height: t.height};

                function b() {
                    if (s) {
                        var e = {
                            getBoundingClientRect: function () {
                                if (!i) return t.getBoundingClientRect()
                            }
                        };
                        return u(e), void s.postMessage({resize: {width: e.width, height: e.height}})
                    }
                    m.width = m.height = null
                }

                function v() {
                    a = null, r && e.removeEventListener("resize", b), i && t && (document.body.removeChild(t), t = null, d = !1)
                }

                return s && !d && s.init(t), d = !0, s && (t.__confetti_initialized = !0), r && e.addEventListener("resize", b, !1), s ? s.fire(n, m, v) : h(n, m, v)
            }

            return g.reset = function () {
                s && s.reset(), a && a.reset()
            }, g
        }

        n.exports = E(null, {useWorker: !0, resize: !0}), n.exports.create = E
    }(function () {
        return void 0 !== t ? t : "undefined" != typeof self ? self : this || {}
    }(), e, !1), t.confetti = e.exports
}(window, {});

class TLFreeGiftBlockFireworks {
    constructor() {
        this.isAnimating = false;
        this.bindedAnimate = this.animate.bind(this);
    }

    connectedCallback() {
        this.addEventListener('click', this.partyTime)
    }

    partyTime() {
        const end = Date.now() + (2000);

        if (this.isAnimating) return;
        this.animate(end);
    }

    animate(end) {
        confetti({
            particleCount: 3,
            angle: 60,
            spread: 55,
            origin: {x: 0}
        });
        confetti({
            particleCount: 3,
            angle: 120,
            spread: 55,
            origin: {x: 1}
        });

        if (Date.now() < end) {
            this.isAnimating = true;
            requestAnimationFrame(() => this.animate(end));
        } else {
            this.isAnimating = false;
        }
    }
}

window.customElements.define('tl-free-gift-block-fireworks', TLFreeGiftBlockFireworks, {extends: "button"})

const tlFreeGiftBlockConstructor = () => {
    window.tlFreeGiftBlock = window.tlFreeGiftBlock || new tlFreeGiftBlock(
        tlFreeGiftBlockVariantMapCollections,
        tlFreeGiftBlockTemplate,
        tlFreeGiftBlockRulesApplyOnAll,
        tlFreeGiftBlockCRulesApplyOnCollection,
        tlFreeGiftBlockRulesApplyOnProduct,
        tlFreeGiftBlockCollectionsOfProduct,
        tlFreeGiftBlockDisplaySetting
    );
}

if(typeof isEnableTLAdvancedFG == "undefined"){
    tlFreeGiftBlockConstructor();
}
